import { UpdateRetailerNetworkUserPolicy } from '@open-commerce/oc-authorization-policies';

import { useCan } from '@occc-app/App/PolicyBasedAccessControl';
import { User_Role } from '@occc/graphql';
import { useUserSelector } from '@occc-app/App/AppContext';

import { useRetailerNetworkUserSelector } from '../../retailer-network-context/use-retailer-network-user.selector';

export const useGetIsUserPermittedToEditRole = (retailerNetworkUuid: string | undefined) => {
  const isUserPermittedTo = useCan();
  const user = useUserSelector();
  const { isRetailerNetworkUser } = useRetailerNetworkUserSelector();

  const isAdmin = user?.userRole === User_Role.Admin;

  if (isAdmin) {
    return true;
  }

  const isCurrentUserPermittedToEdit = isUserPermittedTo(UpdateRetailerNetworkUserPolicy('uuid'), {
    uuid: retailerNetworkUuid,
  });

  if (isCurrentUserPermittedToEdit && !isRetailerNetworkUser) {
    return true;
  }

  return false;
};
